import List from './List'

const productsBrandsResource = {
  list: List,
}

export default productsBrandsResource
